import React, { useEffect, useRef, useState } from 'react';
import { GripHorizontal } from 'lucide-react';

const widthClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  full: 'max-w-full',
};

const Modal = ({ isOpen, onClose, width = 'md', children }) => {
  const modalRef = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });

  // ESC close
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Drag logic
  const onMouseDown = (e) => {
    setIsDragging(true);
    dragOffset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - dragOffset.current.x,
      y: e.clientY - dragOffset.current.y,
    });
  };

  const onMouseUp = () => setIsDragging(false);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50"
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onClick={onClose}
    >
      <div
        ref={modalRef}
        className={`bg-white rounded-lg shadow-xl ${widthClasses[width]} w-full mx-4 absolute`}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          top: '50%',
          left: '50%',
          translate: '-50% -50%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div
          onMouseDown={onMouseDown}
          className="cursor-move select-none flex items-center justify-between p-2 border-b bg-slate-100 rounded-tl-lg rounded-tr-lg"
        >
          <div className="flex items-center gap-2 text-gray-500">
            <GripHorizontal size={18} />
            <span className="text-sm font-medium">Grab & Drag</span>
          </div>

          <button
            className="text-2xl text-gray-500 hover:text-red-500 leading-none"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        {/* BODY */}
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
